export const SMALL_DEVICE_WIDTH = 768;

export const BATTLERUSH_ARENA_TITLE = 'Battlerush Arena';
export const BATTLERUSH_ARENA_APP_STORE_URL = 'https://apps.apple.com/us/app/battlerush-arena/id1558786731';
export const BATTLERUSH_ARENA_GOOGLE_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hightailgames.battlerusharena&hl=en_US&gl=US';
